const state = {
  filters: {},
  datesValue: {},
}

const getters = {
  filters: (state) => state.filters,
  datesValue: (state) => state.datesValue,
}

const mutations = {
  setFilters: (state, filters) => {
    state.filters = filters
  },

  setDatesValue: (state, datesValue) => {
    state.datesValue = datesValue
  },
}

export default {
  state,
  getters,
  mutations,
}
